import { useHistory } from 'react-router-dom';
import { CUSTOMER_FORM_ID, DEFAULT_ERROR_MESSAGE } from 'global/constants';
import { useNotifications } from '../../../components/notifications/use-notifications';
import { useUpdateBuyOrderMutation } from '../../api';
import { Routing } from '../../../global';

export function useUpdateBuyOrder(id: string, shouldRedirect = false) {
  const [updateOrder, updateOrderMeta] = useUpdateBuyOrderMutation();

  const history = useHistory();
  const notifications = useNotifications();

  function onUpdateOrder() {
    updateOrder({ orderId: id })
      .unwrap()
      .then(async () => {
        if (id !== CUSTOMER_FORM_ID) {
          notifications.success({
            description: 'Du har redigerat lagerbolagsbeställningen!',
            durationMs: 3000,
          });
        }
        if (shouldRedirect) {
          history.push(Routing.AdminPanel.buyOrderDetailed(id));
        }
      })
      .catch(() => {
        // TODO: Change the error messages - returned error message is not helpful to the user. Return default one
        notifications.error({
          description: DEFAULT_ERROR_MESSAGE,
          durationMs: 3000,
        });
      });
  }

  return [onUpdateOrder, updateOrderMeta] as const;
}
